import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import LanguagesContent from './LanguagesContent';
import TileHeader from '../../components/TileHeader/TileHeader';
import NewLanguageModal from './NewLanguageModal';
import DeleteLanguageModal from './DeleteLanguageModal';
// api
// import { getAllLanguages } from '../../api/languages';

import { getLanguages } from '../../api/languages';
const Languages = ({
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

  const [languagesList, setLanguagesList] = useState(null);
  const [openNewLanguageModal, setOpenNewLanguageModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [openLanguageModal, setOpenLanguageModal] = useState(false);
  const [detailModalMode, setDetailModalMode] = useState("create");
  const [language, setLanguage] = useState(null);

  const refreshLanguagesList = async () => {
    
    setLoading(true);
    let data = await getLanguages();
    setLanguagesList(data); 
    if(data){
      setLoading(false);
    }
  }
  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const closeModal = () => {
    setOpenLanguageModal(false);
    setLanguage(null);
  };
  
  const addNewLanguage = () => {
    openLanguageModal(true);
  };

  useEffect(async () => {
    refreshLanguagesList();
  }, []);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
            title="Languages"
            subtitle="A list of all languages for attachments."
            size="lg"
        />

        
				{
					loading ? 
					<Loading

          /> 
					:
					<></>
				}
				

        <LanguagesContent
          languagesList={languagesList} 
          setOpenNewLanguageModal={setOpenNewLanguageModal}
          onDeleteClicked={showDeleteConfirm}
          setOpenNewLanguageModal={setOpenLanguageModal}
          setDetailModalMode={setDetailModalMode}
          setLanguage={setLanguage}
          setMode={setDetailModalMode}
          />

        <NewLanguageModal
          open={openLanguageModal}
          languageData={language}
          refreshList={refreshLanguagesList}
          onClose={closeModal}
          mode={detailModalMode}
        />
        <DeleteLanguageModal
          open={openDeleteModal}
          refreshList={refreshLanguagesList}
          onClose={() => setOpenDeleteModal(false)}
          languageList={languagesList}
          deleteItem={deleteItem}
        />
        
      </ContentContainer>
    </Container>
  );
};

export default Languages;